import React from 'react'
import Button from '../Button'
import styles from './styles'
import { HOST } from '../../utils/env'

const OutOfRegion = () => (
  <div className="out-of-region">
    <h1 className="rainbow-text">Stream On...
    </h1>
    <p className="p">Our live channels and TV guide aren't available because you live outside our broadcast area. But, we've got lots of smashing drama box sets and shows that you can stream instead.
    </p>
    <Button
      className="hero-button"
      text="Check them out"
      variant="outOfRegion"
      href={`https://player.${HOST}/`}
    />
    <style jsx>{styles}</style>
  </div>
)

export default OutOfRegion
